export default {
    addItemModal: {
        title: '項目を選択する',
    },
    button: {
        selectComponents: '項目を選択',
    },
    element: {
        client_name: '取引先 - 取引先名',
        client_name_honorific: '取引先 - 敬称付き取引先名 ',
        document_cost: '書類 - 合計金額',
        document_date: '書類 - 発行日',
        document_number: '書類 - 番号',
        document_type_en: '書類 - 種類（英語）',
        document_type_ja: '書類 - 種類（日本語）',
        document_type_legacy:
            '書類 - 種類（旧フォーマット　<0>ヘルプセンター</0>参照）',
        document_type_match: '書類 - 種類（テンプレート言語）',
        partner_name_en: '自社 - 社名（英）',
        partner_name_ja: '自社 - 社名（日）',
        partner_name_match: '自社 - 社名（テンプレート言語）',
    },
    message: {
        noItem: '一つ以上の項目が必要です。',
        success: 'PDFファイル名の設定が保存されました。',
        upgradePlan:
            'この機能は現在のプランではご利用いただけません。<0>こちら</0>をご確認の上、アップグレードしてください。',
    },
    preview: 'プレビュー：',
    section: {
        pdfFilenameClient: '取引先向け',
        pdfFilenameEmployee: '自社向け',
    },
    subTitle: '書類PDFファイル名の項目と並び順の設定。<0>詳しくはこちら</0>',
    table: {
        component: '項目',
        order: '並び順',
    },
    title: 'PDFファイル名',
    tooltip: {
        pdfFilenameClient: '取引先が書類をダウンロードした際のファイル名',
        pdfFilenameEmployee: 'メンバーが書類をダウンロードした際のファイル名',
    },
};
